module.exports = __webpack_public_path__ + "img/3.b10a9968.jpg";